module.exports = __webpack_public_path__ + "img/奔跑吧原始人.00d9f488.jpg";